/* eslint-disable import/prefer-default-export */
import { graphql, useStaticQuery } from 'gatsby'

export const useTreatmenttsData = () => {
  const data = useStaticQuery(graphql`
    query TreatmentData {
      allWpPage(filter: { pageType: { taxonomy: { eq: "treatment" } } }) {
        nodes {
          seo {
            metaDesc
          }
          pageType {
            uri
          }
          language {
            slug
          }
          title
          featuredImage {
            node {
              altText
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 80
                    webpOptions: { quality: 80 }
                    avifOptions: { lossless: true, quality: 80 }
                  )
                }
              }
              mediaItemUrl
              mediaType
            }
          }
          herocontent {
            herocontentimage {
              node {
                altText
                sourceUrl
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 80
                      webpOptions: { quality: 80 }
                      avifOptions: { lossless: true, quality: 80 }
                    )
                  }
                }
                mediaItemUrl
                mediaType
              }
            }
          }
        }
      }
    }
  `)

  return data.allWpPage.nodes
}
